import React from 'react';
import OrderFormField from './OrderFormField';

function OrderSpedizione(props) { 
 
/*    
    const shipmentArray = [
    {
      id: "1",
      name: "Italia - Corriere 24h",
      descr: "Spedizione mediante corriere espresso. Consegna in 24h",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_01_cart",
      requiredPayment: [], 
    },
    {
      id: "2",
      name: "Ritiro In Sede A Bologna",
      descr: "Ritiro ordine presso la nostra sede in Via Marsala, 15 - 40126 Bologna - Italia",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_02_cart",
      requiredPayment: [], 
    },
    {
      id: "3",
      name: "Italia - Corriere 24h",
      descr: "Spedizione mediante corriere espresso. Consegna in 24h",
      imgUrl: "",
      imgAlt: "",
      css: "spedizione_02_cart",
      requiredPayment: [], 
    },
  ];
*/    

  function composeName() {
    let str = props.order.spe_nome + " " + props.order.spe_cognome;
    if (props.order.spe_presso.length > 0)
      str += ", presso " + props.order.spe_presso;
    return str;
  }
  //console.log("FormShipment: "+FormShipment);
  //console.log(props.errList);
  return (
    <form>
      <div className="anagrafica_ordine">
        <div className="titolo_anagrafica_ordine">
          <h2>Informazioni di spedizione{props.title}</h2>
        </div>
        <div className="info_anagrafica_ordine">
          <OrderFormField lbl="" value={composeName()} />
          <OrderFormField lbl="" value={props.order.spe_indirizzo} />
          <div className="">
            <OrderFormField
              lbl=""
              value={
                props.order.spe_cap +
                " - " +
                props.order.spe_citta +
                " (" +
                props.order.spe_provincia +
                ")" +
                " - " +
                props.order.spe_nazione
              }
            />
          </div>
          <div className="">
            <OrderFormField
              lbl=""
              value={"tel. " + props.order.spe_telefono + " - e-mail: " + props.order.email}
            />
          </div>

          {props.order.note_utente.length > 0 ? (
            <div className="note_ordine">
              <OrderFormField
                lbl="Note aggiuntive:&nbsp;"
                value={props.order.note_utente}
              />
            </div>
          ) : null}

          <div className="spedizioni_ordine">
            <OrderFormField lbl="" value={props.order.tipo_spedizione_desc} />
          </div>

          {props.order.assicurato === "1" ? (
            <OrderFormField lbl="" value="Pacco assicurato" />
          ) : null}

          {props.order.data_ordine_str &&
          props.order.data_ordine_str.length > 3 ? (
            <div className="data_consegna_ordine">
              <OrderFormField
                lbl="Ordine del &nbsp;"
                value={props.order.data_ordine_str}
              />
            </div>
          ) : null}
          {props.order.data_evasione_str &&
          props.order.data_evasione_str.length > 3 ? (
            <div className="data_consegna_ordine">
              <OrderFormField
                lbl="Spedito il&nbsp;"
                value={props.order.data_evasione_str}
              />
            </div>
          ) : null}
          {props.order.data_consegna_str &&
          props.order.data_consegna_str.length > 3 ? (
            <div className="data_consegna_ordine">
              <OrderFormField
                lbl="Consegnato il&nbsp;"
                value={props.order.data_consegna_str}
              />
            </div>
          ) : null}
        </div>
      </div>
    </form>
  );
}

export default OrderSpedizione;